// src/seo/FaqSEO.js
import { SEO_CONFIG } from './SEOConfig';

export const FaqSEOData = {
    title: `FAQ | Frequently Asked Questions - ${SEO_CONFIG.orgNameMalayalam}`,
    description: "Common questions about buying Malayalam books from Uyirmozhy via Amazon, Flipkart, or WhatsApp. Learn about shipping, payments, and returns.",
    keywords: "Uyirmozhy FAQ, buy malayalam books help, payment options, shipping charges Kerala, book return policy",
    url: `${SEO_CONFIG.baseUrl}/faq`,

    // FAQPage Schema for Rich Snippets
    schema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "പുസ്തകങ്ങൾ എങ്ങനെ വാങ്ങാം?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "നമ്മുടെ പുസ്തകങ്ങൾ വാങ്ങാൻ മൂന്ന് മാർഗങ്ങൾ ലഭ്യമാണ്: 1. Amazon വഴി, 2. Flipkart വഴി, 3. WhatsApp ഉപയോഗിച്ച് നേരിട്ട് (Direct Purchase)."
                }
            },
            {
                "@type": "Question",
                "name": "Direct Purchase എന്നത് എന്താണ്?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "വെബ്സൈറ്റിലെ WhatsApp ബട്ടൺ ക്ലിക്കുചെയ്ത്, നേരിട്ട് ഞങ്ങളോടൊപ്പം പുസ്തകത്തിന് ഓർഡർ ഇടാൻ നിങ്ങളെ സഹായിക്കുന്ന സൗകര്യമാണ് Direct Purchase."
                }
            },
            {
                "@type": "Question",
                "name": "Direct Purchase-ൽ പേയ്‌മെന്റ് എങ്ങനെ ചെയ്യാം?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "WhatsApp വഴി സംസാരിക്കുമ്പോൾ ഞങ്ങളുടെ ടീം നിങ്ങൾക്ക് ലഭ്യമായ പേയ്‌മെന്റ് മാർഗങ്ങളും (UPI/Bank Transfer മുതലായവ) അറിയിക്കും."
                }
            },
            {
                "@type": "Question",
                "name": "Amazon അല്ലെങ്കിൽ Flipkart വഴി വാങ്ങുന്നതിന് എന്താണ് പ്രത്യേകത?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "അതിവേഗ ഡെലിവറി, ട്രാക്കിംഗ് സൗകര്യം, കൂടാതെ Return/Refund നയങ്ങൾ എന്നിവയാണ് പ്രധാന പ്രത്യേകതകൾ."
                }
            },
            {
                "@type": "Question",
                "name": "പുസ്തകങ്ങളുടെ വില ഒരേപോലെയാണോ?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "പ്ലാറ്റ്ഫോം അനുസരിച്ച് ചെറിയ വിലവ്യത്യാസങ്ങൾ ഉണ്ടാകാം. Latest ഓഫറുകളും ഡീലുകളും Amazon/Flipkart-ൽ കാണാം."
                }
            },
            {
                "@type": "Question",
                "name": "Direct Purchase-ൽ ഷിപ്പിംഗ് ചാർജ് ഉണ്ടാകുമോ?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "അതെ, ഷിപ്പിംഗ് ചാർജ്ജ് സ്ഥലത്തെ ആശ്രയിച്ച് വ്യത്യാസപ്പെടാം."
                }
            },
            {
                "@type": "Question",
                "name": "പുസ്തകം എത്ര ദിവസത്തിനുള്ളിൽ ലഭിക്കും?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Amazon/Flipkart വഴി സാധാരണ 2–5 ദിവസങ്ങൾക്കുള്ളിലും, Direct Purchase വഴി 3–7 ദിവസങ്ങൾക്കുള്ളിലും ലഭിക്കും."
                }
            },
            {
                "@type": "Question",
                "name": "ഞാൻ പുസ്തകം തിരികെ നൽകണമെങ്കിൽ എന്താണ് പ്രക്രിയ?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Amazon/Flipkart വഴി വാങ്ങിയാൽ അവരുടെ Return Policy അനുസരിക്കുക. Direct Purchase ആണെങ്കിൽ കേടുപാടുകൾ ഉണ്ടെങ്കിൽ WhatsApp വഴി ബന്ധപ്പെടുക."
                }
            },
            {
                "@type": "Question",
                "name": "കസ്റ്റമർ സപ്പോർട്ടുമായി എങ്ങനെ ബന്ധപ്പെടാം?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "വെബ്സൈറ്റിലെ WhatsApp ബട്ടൺ ഉപയോഗിച്ച് ഞങ്ങളോട് നേരിട്ട് ആശയവിനിമയം നടത്താം."
                }
            }
        ]
    }
};